export default __webpack_public_path__ + "static/media/Women_Sizing_Chart-Mobile.0dfd5040.png";